import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { FindAllAdminAdminQueryQuery, QueryFindAllAdminAdminArgs } from "../../../../../schemaTypes";
import { useCallback } from "react";



export const findAllAdminAdminQuery = gql`
  query FindAllAdminAdminQuery(
    $page: Int!
    $pageSize: Int!
    $searchText: String
    $sortBy: String
    $sortOrder: String
  ) {
    findAllAdminAdmin(
      page: $page
      pageSize: $pageSize
      searchText: $searchText
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      data {
        adminId
        userId
        shortId
        profilePicture
        firstname
        lastname
        email
        phone
        level
        suspended
        isLocked
        createdAt
        updatedAt
      }
      total
      page
      pageSize
      totalPages
    }
  }
`;

export interface WithFindAllAdminAdmin {
  data: FindAllAdminAdminQueryQuery["findAllAdminAdmin"]["data"]
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  loading: boolean;
  loadMore: () => void;
  hasMoreAdmins: boolean;
}

interface Props {
  variables: QueryFindAllAdminAdminArgs;
  children: (data: WithFindAllAdminAdmin) => React.ReactElement | null;
}

export const FindAllAdminAdminController: React.FC<Props> = ({
  children,
  variables,
}) => {
  const { data, loading, fetchMore } = useQuery<
    FindAllAdminAdminQueryQuery,
    QueryFindAllAdminAdminArgs
  >(findAllAdminAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const findAllAdminAdminData = data?.findAllAdminAdmin?.data || [];
  const page = data?.findAllAdminAdmin?.page || variables.page;
  const pageSize = data?.findAllAdminAdmin?.pageSize || variables.pageSize;
  const total = data?.findAllAdminAdmin?.total || 0;
  const totalPages = data?.findAllAdminAdmin?.totalPages || 0;
  const hasMoreAdmins = page < totalPages;

  const loadMore = useCallback(() => {
    if (!hasMoreAdmins) return;
    fetchMore({
      variables: {
        ...variables,
        page: page + 1,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult || !fetchMoreResult?.findAllAdminAdmin) {
          return prev;
        }
        return {
          ...fetchMoreResult,
          findAllAdminAdmin: {
            ...fetchMoreResult?.findAllAdminAdmin,
            data: [
              ...(prev?.findAllAdminAdmin?.data || []),
              ...(fetchMoreResult?.findAllAdminAdmin?.data || []),
            ],
          },
        };
      },
    });
  }, [fetchMore, variables, page, hasMoreAdmins]);

  return children({
    data: findAllAdminAdminData as any,
    loading,
    loadMore,
    hasMoreAdmins,
    page,
    pageSize,
    total,
    totalPages,
  });
};